import JSZip from 'jszip';
import { buildGameDoc, loadRuntime } from './runtime';
import { detectControls, extractScript } from './analyze';
import { makeIcon } from './poster';
import { brandName } from './brand';

const slug = (s) => (s || 'gioco').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'gioco';

function standaloneCfg(game, settings) {
  return { fps: settings.fps, controls: detectControls(game.code), showPad: 'auto', master: settings.master, sfx: settings.sfx, music: settings.music, bpm: settings.bpm, musicOn: false, haptics: true };
}

function download(blob, name) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}

export async function exportHtml(game, settings) {
  await loadRuntime();
  const html = buildGameDoc(game.code, standaloneCfg(game, settings));
  download(new Blob([html], { type: 'text/html' }), `${slug(game.title)}.html`);
}

export async function exportPwaZip(game, settings) {
  await loadRuntime();
  const head = `<link rel="manifest" href="manifest.json"><meta name="theme-color" content="#6366f1"><meta name="apple-mobile-web-app-capable" content="yes"><meta name="mobile-web-app-capable" content="yes"><meta name="apple-mobile-web-app-status-bar-style" content="black-translucent"><link rel="apple-touch-icon" href="icon-192.png"><script>if('serviceWorker' in navigator)addEventListener('load',function(){navigator.serviceWorker.register('sw.js')});</script>`;
  const html = buildGameDoc(game.code, standaloneCfg(game, settings), head);
  const manifest = {
    name: game.title, short_name: game.title.slice(0, 12), start_url: './', scope: './', display: 'standalone', orientation: settings.orientation === 'landscape' ? 'landscape' : settings.orientation === 'portrait' ? 'portrait' : 'any',
    background_color: '#030712', theme_color: '#6366f1',
    icons: [{ src: 'icon-192.png', sizes: '192x192', type: 'image/png', purpose: 'any maskable' }, { src: 'icon-512.png', sizes: '512x512', type: 'image/png', purpose: 'any maskable' }],
  };
  const sw = `const C='${slug(game.title)}-v${Date.now()}';const F=['./','index.html','manifest.json','icon-192.png','icon-512.png'];self.addEventListener('install',e=>e.waitUntil(caches.open(C).then(c=>c.addAll(F)).then(()=>self.skipWaiting())));self.addEventListener('activate',e=>e.waitUntil(caches.keys().then(k=>Promise.all(k.filter(x=>x!==C).map(x=>caches.delete(x)))).then(()=>self.clients.claim())));self.addEventListener('fetch',e=>e.respondWith(caches.match(e.request).then(r=>r||fetch(e.request))));`;
  const zip = new JSZip();
  zip.file('index.html', html);
  zip.file('manifest.json', JSON.stringify(manifest, null, 2));
  zip.file('sw.js', sw);
  for (const s of [192, 512]) zip.file(`icon-${s}.png`, (await makeIcon(game.cover, game.title, s)).split(',')[1], { base64: true });
  zip.file('LEGGIMI.txt', `${game.title} — PWA autonoma generata da ${brandName()}.\nCarica questa cartella su un hosting HTTPS (Netlify, GitHub Pages, Vercel) e apri il link dal telefono: "Aggiungi a schermata Home".\nOppure apri index.html con doppio clic per giocare offline.`);
  download(await zip.generateAsync({ type: 'blob' }), `${slug(game.title)}-pwa.zip`);
}

export async function copySource(game) {
  await navigator.clipboard.writeText(extractScript(game.code));
}
